export default __webpack_public_path__ + "images/play-874b085cc6438f1169ee27c27fd8182e.svg";